const queryString = require('query-string');
const parsed = queryString.parse(window.location.search);
const inviteId = parsed.inviteId === undefined || parsed.inviteId === null ? '' : parsed.inviteId;
const sessionId = parsed.sessionId === undefined || parsed.sessionId === null ? '' : parsed.sessionId;
const clientId =  parsed.clientId === undefined || parsed.clientId === null ? '' : parsed.clientId;
const janusDataGathererId = parsed.janusDataGathererId === undefined || parsed.janusDataGathererId === null ? '' : parsed.janusDataGathererId;
const janusTenantId = parsed.janusTenantId === undefined || parsed.janusTenantId === null ? '' : parsed.janusTenantId;
const personalInvite = parsed.personalInvite === undefined || parsed.personalInvite === null ? false : parsed.personalInvite;
var versionId;

const tempVer = parseInt(sessionStorage.getItem('temp-version-id'));

if (isNaN(tempVer)) {
  if (parsed.versionId === undefined || null) {
    versionId = -1;
  } else {
    versionId = parsed.versionId;
  }
} else {
  if (tempVer === -1) {
    if (parsed.versionId === undefined || null) {
      versionId = -1;
    } else {
      versionId = parsed.versionId; 
    }
  } else {
    versionId = tempVer;
  }
}

if(!isNaN(versionId) && versionId !== '') {
  sessionStorage.setItem('temp-version-id', versionId);
}

export { inviteId, sessionId, versionId, clientId, janusDataGathererId, janusTenantId, personalInvite }